import { Form, Formik } from 'formik';
import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, TextField } from 'src/components';
import Loader from 'src/components/loader';
import { fetchDetails } from 'src/redux/action/details.action';
import { fetchSetting } from 'src/redux/action/setting.action';
import Service from 'src/setup/network';
import { toastAlert } from 'src/utils/toastAlert';

interface IProps {
  gtag?: string;
  loading?: boolean;
}

const GoogleAnalytics: React.FC<IProps> = ({ gtag, loading }) => {
  const dispatch = useDispatch();

  const handleSubmit = async (values: any) => {
    const payload = {
      gTag: values.gTag,
    };
    try {
      await Service.post('/settings/update', payload);
      toastAlert('success', `Social Links are successfully updated`);
      dispatch(fetchSetting() as any);
      dispatch(fetchDetails() as any);
    } catch (err: any) {
      toastAlert('error', err?.response?.data?.message);
    }
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <Formik
          initialValues={{ gTag: gtag || '' }}
          validateOnMount
          onSubmit={handleSubmit}
        >
          {({ isSubmitting, isValid }) => (
            <Form className="mt-4">
              <>
                <div className="relative"></div>
                <TextField
                  label={'Google Analytics ID'}
                  name="gTag"
                  placeholder="G-ABC123XYZ"
                />

                <div className="flex items-center justify-end my-2">
                  <Button
                    text="save detail"
                    variant="primary"
                    type="submit"
                    isSubmitting={isSubmitting}
                    isValid={isValid}
                  />
                </div>
              </>
            </Form>
          )}
        </Formik>
      )}
    </>
  );
};

export default React.memo(GoogleAnalytics);
